import { render, staticRenderFns } from "./JagfxSymbolArea.vue?vue&type=template&id=101c22c8&"
import script from "./JagfxSymbolArea.vue?vue&type=script&lang=js&"
export * from "./JagfxSymbolArea.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports